function ContextItemLoadingIndicator () {
  return <div className="flex justify-between items-center">
  <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-[85px] animate-pulse" />
  </div>
}
export default ContextItemLoadingIndicator
